import React from 'react';
import { twMerge } from 'tailwind-merge';
interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  className?: string;
}
export function Toggle({
  checked,
  onChange,
  label,
  className
}: ToggleProps) {
  return <button type="button" role="switch" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} className={twMerge('relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors', checked ? 'bg-brand-600' : 'bg-ink-300', className)} data-id="element-398" data-mp="17zhst0a4z5lc">
      <span className={twMerge('inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform', checked ? 'translate-x-[18px]' : 'translate-x-[2px]')} data-id="element-399" data-mp="p7p25cijhwgs" />
    </button>;
}